import React, { useRef, useState } from 'react';
import moment from 'moment';

import Filter from '@/pages/dashboard/components/NewFilter';
import { timeRange } from '@/pages/dashboard/pages/engagement/_config';
import { setBtnPointLog } from "@/pages/dashboard/utils/utils";
import { formatDateFromFilterValue } from "@/pages/dashboard/utils/formatDate";
import { useSelector } from 'umi';
import { getDateDefault } from '../../utils/dateUtils';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:setFilterLoading 筛选器loading设置，透传到筛选器组件内部，获取到筛选器列表时区等数据之后，设置为false，测试才可进行页面和组件中的接口调用
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

// 筛选器路径
const FILTER_PATH = 'engagement/active/onlineAnalysis';

const ActiveOnlineFilter = (props: any) => {
  const { filterConfirm, filterReset, buttonLogConfig, setFilterLoading, filterInit, openSticky = false, children, isHaveFilterSave, timeZone = 0 } = props;
  // daily筛选器继承逻辑
  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新
  const { seasonInfo } = useSelector((state: any) => 
  // 初始可能为undefied,在此加兜底
		 ({
      seasonInfo: state?.dashboardSetting?.gameConfig?.season_info || { date: [], week: [], month: [] },
    })
  );

  // 设置inputList
  const [inputList] = useState([{
    type: 'rangeDaily',
    key: 'rangeTime',
    default: getDateDefault({timeType: 'day', timeZone, startNum: 14, endNum: 1}),
    extraShortcut: seasonInfo
  }]);

  const handleConfirm = (value: any) => {
    filterValueRef.current = value;
    const formattedValue = formatDateFromFilterValue(value, 'Day');
    filterConfirm?.({
      ...formattedValue,
      pagePath: FILTER_PATH
    });
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, formatDateFromFilterValue(value, 'Day'));
  };

  const handleReset = (value: any) => {
    filterValueRef.current = value;
    const formattedValue = formatDateFromFilterValue(value, 'Day');
    filterReset?.({
      ...formattedValue,
      pagePath: FILTER_PATH
    });
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, formatDateFromFilterValue(value, 'Day'), true);
  };

  const handleInit = (value: any) => {
    filterValueRef.current = value;
    const formattedValue = formatDateFromFilterValue(value, 'Day');
    filterInit?.({
      ...formattedValue,
      pagePath: FILTER_PATH
    });
    setFilterLoading(false);
  };

  // const handleChange = (key: string, value: any) => {
  // 	if (key === 'rangeTime') {
  // 		filterValueRef.current = {
  // 			...filterValueRef.current,
  // 			[key]: {
  // 				type: value.type,
  // 				value: value.value,
  // 			},
  // 		};
  // 	}
  // };

  return (
    <Filter
      config={props.config}
      openSticky={openSticky}
      path={FILTER_PATH}
      value={filterValueRef.current}
      latestDateType={''}
      inputList={inputList}
      onInit={handleInit}
      onConfirm={handleConfirm}
      onReset={handleReset}
		  isHaveFilterSave={isHaveFilterSave}
    >
      {children}
    </Filter>
  );
};

export default ActiveOnlineFilter;
